import { useQuery } from '@tanstack/react-query';
import { fetchDeviceModels } from '@/api/common';

export const deviceModelsKeys = {
  all: ['deviceModels'] as const,
};

export function useDeviceModels() {
  return useQuery({
    queryKey: deviceModelsKeys.all,
    queryFn: fetchDeviceModels,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
